import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const SummaryContainer = styled.div``

export const BrandSection = styled.section`
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
`

export const BrandHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const BrandTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: ${Tokens.ColorTextPrimary};
`

export const BrandBadge = styled.span<{ $success: boolean }>`
  font-size: 12px;
  font-weight: 600;
  border-radius: 999px;
  padding: 4px 10px;
  color: ${({ $success }) => ($success ? '#166534' : '#991b1b')};
  background: ${({ $success }) => ($success ? '#dcfce7' : '#fee2e2')};
`

export const SummaryDataSourceSection = styled.div`
  margin-bottom: 32px;
`

export const SummaryDataSourceTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  padding: 30px 0;
  color: ${Tokens.ColorTextPrimary};
`

export const SummaryCompanyFocusContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
`

export const SummaryFocusItem = styled.div``

export const SummaryFocusTitle = styled.h5`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const FocusTagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

export const FocusTag = styled.span`
  padding: 4px 8px;
  background-color: ${Tokens.ColorUIPrimaryLight};
  color: ${Tokens.ColorTextPrimary};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
`

export const SummaryPolarityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 12px;
`

export const SummaryPolarityHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  h4 {
    margin: 0;
    color: ${Tokens.ColorTextPrimary};
    font-size: 18px;
    font-weight: 600;
  }

  > div:first-child {
    transform: scale(0.8);
    transform-origin: center;
  }
`

export const SummaryPolarityHeaderTitle = styled.h4`
  margin: 0;
  color: ${Tokens.ColorTextPrimary};
  font-size: 18px;
  font-weight: 600;
`

export const CompoundEmojiContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

export const EmojiGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const EmojiDivider = styled.h4`
  margin: 0;
`

export const TermsContainer = styled.div``

export const TermFieldTitle = styled.h6`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin: 0 0 4px 0;
`

export const TermFieldTitleSpaced = styled.h6`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin: 8px 0 4px 0;
`

export const RuleNumberSpan = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #9ca3af;
  flex-shrink: 0;
  min-width: 20px;
`

export const SummaryRulesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: ${Tokens.ColorTextSecondary};
    font-style: italic;
  }

  h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${Tokens.ColorTextPrimary};
  }
`

export const SummaryRulesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 8px;
`

export const SummaryRuleItem = styled.div<{ $isBullet?: boolean }>`
  font-size: 14px;
  color: ${Tokens.ColorTextPrimary};
  line-height: 1.5;
  padding: 6px 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  position: relative;

  ${({ $isBullet }) =>
    $isBullet &&
    `
    padding-left: 20px;
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 12px;
      width: 6px;
      height: 6px;
      background-color: #9CA3AF;
      border-radius: 50%;
      flex-shrink: 0;
    }
  `}
`

export const NoTermsText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`

export const NoRulesText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`
